import { SignedIn, SignedOut, SignInButton } from '@clerk/clerk-react';
import JoinMarket from './JoinMarket';

/**
 * Garage seller entry: /vendor/login
 * Signed-out users see sign-in CTA; signed-in users see JoinMarket form (address entry).
 */
export default function VendorLogin() {

  return (
    <>
      <SignedOut>
        <div className="flex flex-col gap-6">
          <h1 className="text-3xl font-semibold">Garage Seller Sign In</h1>
          <p className="text-lg text-slate-600 dark:text-slate-400">
            Sign in to create your garage sale. After signing in, you'll enter your address to get started.
          </p>
          <SignInButton mode="modal" forceRedirectUrl={window.location.origin + window.location.pathname}>
            <button
              type="button"
              className="h-16 text-2xl w-full rounded-xl font-semibold bg-indigo-600 text-white hover:bg-indigo-700 active:bg-indigo-800 transition-colors"
            >
              Sign in
            </button>
          </SignInButton>
        </div>
      </SignedOut>
      <SignedIn>
        <JoinMarket />
      </SignedIn>
    </>
  );
}
